var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noPage"},[_c('Header'),_vm._v(" 您访问的页面不存在 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }